import Api from "./base/api-base";

export default class ConstructionDepartmentApi {

  list(construction_id) {
    return Api.get({
      endpoint: Api.endpoint.construction_department,
      id: construction_id
    });
  }
}
